'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
* java 版本：
* http://git.souche.com/hero/souche-qiwa/blob/master/qiwa-framework/src/main/java/com/souche/qiwa/util/CarImgUrlUtil.java
*
* ===
*
* qiniu 文档：
* http://developer.qiniu.com/code/v6/api/kodo-api/image/imageview2.html
*
* ===
*
* aliyun 文档：https://help.aliyun.com/document_detail/32217.html
*
* e:1.缩放优先边，这里指定按短边优化 4.缩略优先边，缩略后填充必须指定值为4
*
* c:是否进行裁剪。如果是想对图进行自动裁剪，必须指定为1
*
* o:自动旋转，车辆照片使用2
*
* p:倍数百分比。 小于100，即是缩小，大于100即是放大。
*
* wh:只有当原图是四通道(即有透明背景)的png, webp, bmp转换成jpg格式时才有效果。即把原图当中的透明背景以白色填充，如果不指定wh,
* 那么上述图转换成jpg时，透明背景将会变成黑色。
*
* Q:不在页面上显示的图片、多倍显示的图片使用 60Q
*
* an:按原图格式返回，如果原图是gif, 此时返回gif格式第一帧,保存成jpg格式，而非gif格式，如果我想保存成gif格式，必须增加1an参数
*/
var HTTP = 'http:';
var HTTPS = 'https:';
var QINIU_IMG_URL_WORD = '//';
var ALIYUN_IMG_URL_PRE = '//img.souche.com/';
var DEFAULT_IMAGE = '//img.souche.com/20160813/png/e340864b870d28aecf884998b62b2d73.png';

exports.default = {
    /**
     * @param {String} 要处理的 url 字符串
     * @param {Object} 处理参数
     *    width: 图片宽度
     *    height: 图片高度
     *    defaultImage: 默认图片
     * @return {String} 处理后的 url
     */
    imageSuffix: function imageSuffix(url, options) {
        if (!url) return (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object' && options.defaultImg || DEFAULT_IMAGE;

        var width = options.width;
        var height = options.height;

        return this._formatUrl(url, '@' + width + 'w_' + height + 'h_1e_1c_2o_60Q_1pr_200p_1wh_1an.src', '?imageView2/1/w/' + width * 2 + '/h/' + height * 2 + '/.jpg');
    },


    /**
     * 一般方法
     *
     * @param  String inputImg [description]
     * @param  int width    [description]
     * @param  int height   [description]
     * @return String          [description]
     */
    formatUrl: function formatUrl(inputImg, width, height) {
        if (width && height) {
            // 限制宽高
            if (!(width > 0 && height > 0)) {
                console.error('[souche-util]: width / height\u4E0D\u80FD\u5C0F\u4E8E0,\u5F53\u524Dwidth=' + width + '/height=' + height);
            }
            return this._formatUrl(inputImg, '@' + width + 'w_' + height + 'h_1e_1c_2o_60Q_1pr_200p_1wh_1an.src', '?imageView2/1/w/' + width * 2 + '/h/' + height * 2 + '/.jpg');
        }
        if (width) {
            // 限制宽度
            if (!(width > 0)) {
                console.error("error:width不能小于0,当前width=" + width);
            }
            return this._formatUrl(inputImg, "@" + width + "w_2o_60Q_1pr_200p_1wh_1an.src", "?imageView2/2/w/" + width * 2 + "/.jpg");
        }
        return this._formatUrl(inputImg, "@2o_60Q_1pr_200p_1wh_1an.src", "?imageView2/1/.jpg");
    },

    /**
     * H5 专用
     *
     * @param  String inputImg [description]
     * @param  int width    [description]
     * @param  int height   [description]
     * @return String          [description]
     */
    formatH5Url: function formatH5Url(inputImg, width, height) {
        return this.formatUrl(inputImg, width, height);
    },

    /**
     * 分享 logo 专用方法: 正方形，填充，白色背景填充。可自定义宽高
     *
     * @param  String inputImg [description]
     * @param  int width    [description]
     * @return String          [description]
     */
    formatShareImgUrl: function formatShareImgUrl(inputImg, width) {
        if (width) {
            if (!(width > 0)) {
                console.error("error:width不能小于0,当前width=" + width);
            }
            return this._formatUrl(inputImg, "@" + width + "w_" + width + "h_4e_1wh_2o_60Q.jpg", "?imageView2/1/w/" + width + "/h/" + width + "/.jpg");
        }
        return this._formatUrl(inputImg, "@300w_300h_4e_1wh_2o_60Q.jpg", "?imageView2/1/w/300/h/300/.jpg");
    },

    /**
     * 和分享的图片处理的的区别，这个需要传高度
     */
    formatBaiduImgUrl: function formatBaiduImgUrl(inputImg, width, height) {
        if (!width || !height) {
            console.error("error:width/height不能为空");
        }
        return this._formatUrl(inputImg, "@" + width + "w_" + height + "h_4e_1wh_2o_60Q.jpg", "?imageView2/1/w/" + width + "/h/" + height + "/.jpg");
    },

    /**
     * H5Logo 专用方法：不得压缩，透明。H5Logo 全站唯一，可以有效利用缓存
     *
     * @param  String inputImg [description]
     * @return String          [description]
     */
    formatH5LogoUrl: function formatH5LogoUrl(inputImg) {
        return this._formatUrl(inputImg, "@80h_200p.png", "?imageView2/1/.png");
    },

    /**
     * 底层方法，识别阿里云/七牛，添加相应后缀
     *
     * @param  String inputImg 当前方法校验，调用方不需要校验
     * @param  String _aliyun  [description]
     * @param  String _qiniu   [description]
     * @return String          [description]
     */
    _formatUrl: function _formatUrl(inputImg, _aliyun, _qiniu) {
        if (!inputImg) {
            console.error("[souche-util]: inputImg 不能为空,当前inputImg=" + inputImg);
        }
        var inputImgLowerCase = inputImg.toLowerCase();
        if (inputImgLowerCase.indexOf(HTTPS) == 0) {
            inputImgLowerCase = inputImgLowerCase.substring(HTTPS.length);
            inputImg = inputImg.substring(HTTPS.length);
        } else if (inputImgLowerCase.indexOf(HTTP) == 0) {
            inputImgLowerCase = inputImgLowerCase.substring(HTTP.length);
            inputImg = inputImg.substring(HTTP.length);
        }

        if (inputImgLowerCase.indexOf(ALIYUN_IMG_URL_PRE) == 0) {
            return inputImg.indexOf('@') != -1 ? inputImg : inputImg + _aliyun;
        } else if (inputImgLowerCase.indexOf(QINIU_IMG_URL_WORD) == -1) {
            return inputImg.indexOf('@') != -1 ? ALIYUN_IMG_URL_PRE + inputImg : ALIYUN_IMG_URL_PRE + inputImg + _aliyun;
        } else {
            return inputImg + _qiniu;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-util/lib/image.js
// module id = mz+y
// module chunks = 11